import React from 'react'

function Logo() {
  return (
    <div className='app__navbar-logo'>
    <a href='/' style={{
        textDecoration:'none', 
        display:'flex'
        }}>
    {/* <img src={images.logo} alt="logo" />  */}
    <h2 style={{
            color: '#f1f5f9',
            background: 'rgb(33,71,19)',
            padding: '0 0.3rem 0 0.3rem',
            borderRadius: '0 0.8rem 0 0.8rem'
        }}>RP</h2><h2 style={{color: 'rgb(33,71,19)'}}>Tech</h2>
    </a>
    </div>
  )
}

export default Logo